/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Chars_TitleInputs */



/**
* | output |
* | --- |
* | "Character count warning: character count is above max value" |
*
* @param {Event_Warning_Chars_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_chars_title = /** @type {((inputs?: Event_Warning_Chars_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Chars_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alerte caractères : le nombre de caractères dépasse la valeur maximale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Warnung wegen zu hoher Zeichenanzahl: Die maximale Zeichenanzahl wurde überschritten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avviso sul conteggio dei caratteri: il conteggio dei caratteri è superiore al valore massimo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предупреждение о превышении лимита символов: количество символов превышает максимально допустимое значение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Advertencia de conteo de caracteres: el conteo de caracteres supera el valor máximo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字符数警告：字符数已超过最大值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字数警告: 文字数が最大値を超えています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्णों की संख्या संबंधी चेतावनी: वर्णों की संख्या अधिकतम मान से अधिक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aviso sobre o limite de caracteres: o número de caracteres está acima do valor máximo permitido.")
	return /** @type {LocalizedString} */ ("Character count warning: character count is above max value")
});